import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from '@/utils';
import { Menu, MenuArrow, MenuIcon, MenuItem, MenuLink, MenuSub, MenuTitle, MenuToggle, KeenIcon } from '@/components';
import { useResponsive, useCompanyLogo } from '@/hooks';
import { useMainLayout } from '..';
import { useLanguage } from '@/i18n';
import { useAuthContext } from '@/auth';

const PublicHeaderLogo = () => {
  const { auth } = useAuthContext();
  const companyLogo = useCompanyLogo();
  const desktopMode = useResponsive('up', 'lg');
  const {
    setMobileMegaMenuOpen
  } = useMainLayout();
  const {
    isRTL
  } = useLanguage();
  const handleSidebarOpen = () => {
    setMobileMegaMenuOpen(true);
  };
  const teams = [{
    title: 'MetronicTeam',
    icon: 'profile-circle',
    urlPartial: '/public-profile/',
    path: '/public-profile/profiles/default'
  }, {
    title: 'KeenTeam',
    icon: 'setting-2',
    urlPartial: '/account/',
    path: '/'
  }];
  const months = [{
    title: 'UrbanNest'
  }, {
    title: 'Celestial Finds'
  }, {
    title: 'BohoChic Bazaar '
  }];
  return <div className="flex items-center gap-1 grow lg:grow-0 min-w-0"> {/* lg:w-[400px] */}
    {/* {auth.user.referral_attorney !== 1 && (
        <button type="button" onClick={handleSidebarOpen} className="btn btn-icon btn-light btn-clear btn-sm -ms-2.5 lg:hidden">
          <KeenIcon icon="menu" />
        </button>
      )} */}

    <div className="flex items-center gap-2 min-w-0">
      {/* <Link to="/" className='flex items-center gap-2'> */}
      <img
        src={companyLogo || toAbsoluteUrl('/media/app/placeholder-logo.png')}
        className="h-8 sm:h-10 lg:h-[50px] w-auto max-w-[96px] sm:max-w-[160px] lg:max-w-[220px] object-contain"
        alt="logo"
        onError={(e) => { e.currentTarget.src = toAbsoluteUrl('/media/app/placeholder-logo.png'); }}
      />
      {/* </Link> */}
    </div>

    {/* {desktopMode && <div className="lg:flex items-center">
          <div className="border-e border-gray-200 h-5 mx-4"></div>

          <Menu className="menu-default">
            <MenuItem toggle="dropdown" trigger="hover" dropdownProps={{
          placement: isRTL() ? 'bottom-end' : 'bottom-start',
          modifiers: [{
            name: 'offset',
            options: {
              offset: [0, 10] // [skid, distance]
            }
          }]
        }}>
              <MenuToggle className="text-gray-900 text-sm font-medium">
                TeamRafa
                <MenuArrow>
                  <KeenIcon icon="down" />
                </MenuArrow>
              </MenuToggle>
              <MenuSub className="menu-default w-48 py-2">
                {teams.map((team, index) => <MenuItem key={index}>
                    <MenuLink path={team.path}>
                      {team.icon && <MenuIcon>
                          <KeenIcon icon={team.icon} />
                        </MenuIcon>}
                      <MenuTitle>{team.title}</MenuTitle>
                    </MenuLink>
                  </MenuItem>)}
              </MenuSub>
            </MenuItem>
          </Menu>

          <div className="border-e border-gray-200 h-5 mx-4"></div>

          <Menu className="menu-default w-[120px]">
            <MenuItem toggle="dropdown" trigger="hover" dropdownProps={{
          placement: isRTL() ? 'bottom-end' : 'bottom-start',
          modifiers: [{
            name: 'offset',
            options: {
              offset: [0, 0] // [skid, distance]
            }
          }]
        }}>
              <MenuToggle className="btn btn-light btn-sm flex-nowrap">
                <span className="flex items-center me-1">
                  <KeenIcon icon="shop" className="!text-md" />
                </span>
                <span className="hidden md:inline text-nowrap">RafaShop</span>
                <span className="flex items-center">
                  <KeenIcon icon="down" className="!text-xs" />
                </span>
              </MenuToggle>
              <MenuSub className="menu-default w-48 py-2 scrollable-y max-h-[250px]">
                {months.map((item, index) => <MenuItem key={index}>
                    <MenuLink path="#">
                      <MenuTitle>{item.title}</MenuTitle>
                    </MenuLink>
                  </MenuItem>)}
              </MenuSub>
            </MenuItem>
          </Menu>
        </div>} */}
  </div>;
};
export { PublicHeaderLogo };
